import { memo } from 'react';
import { VoteIndicator as VoteIndicatorIcon } from '@mentimeter/ragnar-visuals';
import { Box } from '@mentimeter/ragnar-ui/box';
import { IndicationNumber } from '../IndicationNumbers';
import { Indication } from '../Indication';
import { getCompactNumberFormat } from './getCompactNumberFormat';

interface RespondentsIndicatorProps {
  respondedCount: number | undefined;
  joinCount: number;
}

export const RespondentsIndicator = memo<RespondentsIndicatorProps>(
  ({ respondedCount, joinCount }: RespondentsIndicatorProps) => {
    const indicationString =
      respondedCount === undefined
        ? getCompactNumberFormat(joinCount)
        : `${getCompactNumberFormat(respondedCount)} / ${getCompactNumberFormat(joinCount)}`;

    const shouldShow =
      joinCount > 0 || (respondedCount !== undefined && respondedCount > 0);

    const tooltipText =
      respondedCount === undefined
        ? 'Participants joined'
        : 'Participants responded / joined';

    return (
      <Box data-testid="vote-indicator" title={tooltipText}>
        <Indication>
          <IndicationNumber
            number={{
              value: indicationString,
              shouldShow,
            }}
          />
          <VoteIndicatorIcon size={3} color="text" />
        </Indication>
      </Box>
    );
  },
);
